import { useIntl } from "react-intl";
import flat from "flat";
import en from "../locale/en_US.json";
import { ReactNode, useCallback } from "react";
import React from "react";
import { useIntlSSRCache } from "@app/utils/IntlSSRCache";
import { isBrowserEnv } from "@app/utils/constants";
import { useIntlCacheInClient } from "@app/utils/IntlSSRCache";
import commonEn from "locale/common/en_US.json";

const faltedEn = flat({ ...en, ...commonEn });

export type TIntlFunc = (
  id: string,
  defaultMessage?: string,
  values?: Record<
    string,
    | string
    | number
    | boolean
    | Date
    | null
    | undefined
    | ((text: ReactNode) => ReactNode)
  >
) => string | ReactNode | number;

export default function useMyIntl() {
  const { formatMessage: f } = useIntl();
  const setSSRCache = useIntlSSRCache();

  const cacheIntl = useIntlCacheInClient();

  return useCallback(
    function (
      id: string,
      defaultMessage?: string,
      values?: Record<
        string,
        | string
        | number
        | boolean
        | Date
        | null
        | undefined
        | React.ReactNode
        | ((text: ReactNode) => ReactNode)
      >
    ) {
      !isBrowserEnv && setSSRCache(id);
      return f(
        {
          id: id,
          defaultMessage: cacheIntl[id] || defaultMessage || faltedEn[id],
        },
        values
      );
    },
    [f, setSSRCache, cacheIntl]
  );
}
